/**
 * Validates that a string is a valid MongoDB ObjectId format (24 hex characters).
 *
 * Use this to guard API calls that require a real document / entity ID,
 * preventing requests with temporary placeholder IDs (e.g. NanoIDs) that
 * would be rejected by the backend with a 422.
 */
export function isValidObjectId(id: string | null | undefined): boolean {
  if (!id || typeof id !== 'string') return false;
  return /^[a-fA-F0-9]{24}$/.test(id);
}
